/**
 * @generated SignedSource<<d7bd69b27d0e3d0b2d9f09d30bd82e43>>
 * @relayHash 7f8e4352702cba5e9930ba4854274a94
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bae753e26ee5d73e9680b1b7e053c0a684a5f2c4fed39a0c35c49206982f0701

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CaseNotesPageQuery } from './CaseNotesPageQuery.graphql';

const node: PreloadableConcreteRequest<CaseNotesPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "bae753e26ee5d73e9680b1b7e053c0a684a5f2c4fed39a0c35c49206982f0701",
    "metadata": {},
    "name": "CaseNotesPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
